<template>
  <div class="card py-2 px-2 shadow-3 h-100" :class="props.additionalClasses">
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
  import { defineProps } from 'vue'

  interface Props {
    additionalClasses?: string
  }

  const props = defineProps<Props>()
</script>

<style scoped>
  .card {
    border-radius: var(--border-radius-default);
    border: 1px solid var(--grey-300);
  }

  .py-none {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
</style>
